import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function greaterThanValidator(controlName: string, compareControlName: string): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const controlValue = control.get(controlName);
    const compareControlValue = control.get(compareControlName);

    if (!controlValue || !compareControlValue) {
      return { largerThan: true };
    }

    if (controlValue.errors && !controlValue.errors['greaterThan']) {
      // Return if another validator has already found an error on the compare control

      return null;
    }

    if (!controlValue.value || !compareControlValue.value) {
      // Return if one of the values is not set
      return null;
    }

    if (controlValue.value <= compareControlValue.value) {
      controlValue.setErrors({ greaterThan: true });
    } else {
      controlValue.setErrors(null);
    }

    return null;
  };
}
